import React, { useState, useEffect, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faStar, faCopy, faEdit, faTrash, faChevronLeft, faDownload, faUser, faHistory, faKey, faEyeSlash, faFile, faSpinner } from '@fortawesome/free-solid-svg-icons';
import { CartaoModal, VerificarAcessoModal, HistoricoModal, ModalPermissoesGrupo } from '../Modais/Modal';
import { validarOTP } from '../ValidarForm/ValidarForm'
import ModalPermissoes from '../Modais/Permissoes';

import checklistGif from '../../assets/img/checklist.gif';
import defaultIcon from '../../assets/img/Icone-cartao/default_card.png';
import visaIcon from '../../assets/img/Icone-cartao/VISA.png';
import mastercardIcon from '../../assets/img/Icone-cartao/MASTERCARD.png';
import eloIcon from '../../assets/img/Icone-cartao/ELO.png';
import Favoritos from '../Favoritos/Favoritos';

const Registro = ({
    selectedGrupoDetalhes = { registros: [], opcaoEdicao: '' },
    setSelectedGrupoDetalhes,
    grupos,
    setGrupos,
    showAddRecordFormOnly,
    setShowAddRecordFormOnly,
    isEditing,
    setIsEditing,
    handleBackToCards,
    showCopySuccess,
    setShowCopySuccess,
    getCookie,
    showToast,
    ...props
}) => {
    const [registroSelecionado, setRegistroSelecionado] = useState(null);
    const [editingRecord, setEditingRecord] = useState(null);
    const [showPasswordPopup, setShowPasswordPopup] = useState(false);
    const [passwordToShow, setPasswordToShow] = useState(' ');
    const [sistemaTipoSelecionado, setSistemaTipoSelecionado] = useState('URL');
    const [cardType, setCardType] = useState('Desconhecido');
    const [arquivo, setArquivo] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [recordsPerPage] = useState(10); // Número de registros por página
    const [newRecord, setNewRecord] = useState({
        titulo: '',
        login: '',
        senha: '',
        sistemaTipo: 'URL',
        sistemaValor: '',
        notas: '',
        arquivo: null,
        numeroCartao: '',
        cpfCnpj: '',
        nomeCartao: '',
        mesVencimento: '',
        anoVencimento: '',
        cvv: ''
    });

    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    const [loadingSearch, setLoadingSearch] = useState(false);
    const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
    const [recordToDelete, setRecordToDelete] = useState(null);
    const [showCartaoModal, setShowCartaoModal] = useState(false);
    const [showVerificarAcessoModal, setShowVerificarAcessoModal] = useState(false);
    const [cartaoSelecionado, setCartaoSelecionado] = useState(null);
    const [loadingSenha, setLoadingSenha] = useState(false);
    const [showPermissoesModal, setShowPermissoesModal] = useState(false);

   
    const [showHistoricoModal, setShowHistoricoModal] = useState(false);
    const [historico, setHistorico] = useState([]);
    const [loadingHistorico, setLoadingHistorico] = useState(false);
    const [fileName, setFileName] = useState(null);
    const fileInputRef = useRef(null);
    const [fileErrorTrigger, setFileErrorTrigger] = useState(0); 
    const [loading, setLoading] = useState(false);
    const [uploadError, setUploadError] = useState(null);
    const [hashArquivo, setHashArquivo] = useState(null);
    const [acaoPendente, setAcaoPendente] = useState(null);
    const [acessoVerificado, _setAcessoVerificado] = useState(false);
    const acessoVerificadoRef = useRef(false);

    const [searchTerm, setSearchTerm] = useState('');
    const [searchTimeout, setSearchTimeout] = useState(null);
    const [filteredRecords, setFilteredRecords] = useState([]);
    const [copiarChave, setCopiarChave] = useState(false);

    useEffect(() => {
    if (selectedGrupoDetalhes?.registros) {
        setFilteredRecords(selectedGrupoDetalhes.registros);
    }
    }, [selectedGrupoDetalhes]);

    const currentRecords = filteredRecords.slice(indexOfFirstRecord, indexOfLastRecord);

    const handleSearch = (term) => {
    setSearchTerm(term);
    setLoadingSearch(true); // Ativa o loading
    
    if (searchTimeout) {
        clearTimeout(searchTimeout);
    }
    
    const timeout = setTimeout(() => {
        if (!term.trim()) {
        setFilteredRecords(selectedGrupoDetalhes?.registros || []);
        } else {
        const lowerTerm = term.toLowerCase();
        const filtered = (selectedGrupoDetalhes?.registros || []).filter(registro => {
            return (
            (registro.titulo && registro.titulo.toLowerCase().includes(lowerTerm)) ||
            (registro.login && registro.login.toLowerCase().includes(lowerTerm)) ||
            (registro.sistema && registro.sistema.toLowerCase().includes(lowerTerm)) ||
            (registro.notas && registro.notas.toLowerCase().includes(lowerTerm)) ||
            (registro.numero && registro.numero.toLowerCase().includes(lowerTerm)) ||
            (registro.nome && registro.nome.toLowerCase().includes(lowerTerm))
            );
        });
        setFilteredRecords(filtered);
        }
        setCurrentPage(1);
        setLoadingSearch(false); // Desativa o loading após a busca
    }, 800);

    setSearchTimeout(timeout);
    };



    const isUrl = (string) => {
        if (!string) return false;
      
        // Verifica se é um IP (v4)
        const ipRegex = /^(?:\d{1,3}\.){3}\d{1,3}$/;
        if (ipRegex.test(string)) return false;
      
        try {
          // Se for uma URL completa com http(s)
          if (string.startsWith('http://') || string.startsWith('https://')) {
            return true;
          }
      
          // Verifica se é um domínio válido (ex: exemplo.com)
          const domainRegex = /^[a-z0-9.-]+\.[a-z]{2,}$/i;
          if (domainRegex.test(string) && !string.includes(' ')) {
            return true;
          }
      
          return false;
        } catch (_) {
          return false;
        }
      };
      

    const setAcessoVerificado = (value) => {
        acessoVerificadoRef.current = value;
        _setAcessoVerificado(value);
    };
    
    const paginate = (pageNumber) => setCurrentPage(pageNumber);
    
    const formatCPF = (cpf) => {
        if (!cpf) return '';
        // Remove tudo que não é dígito
        const digits = cpf.replace(/\D/g, '');
        // Aplica a formatação
        return digits.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
    };

    const nextPage = () => {
        if (currentPage < Math.ceil(selectedGrupoDetalhes.registros.length / recordsPerPage)) {
            setCurrentPage(currentPage + 1);
        }
    };

    const prevPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    const formatCardNumber = (cardNumber) => {
        if (!cardNumber) return '•••• •••• •••• ••••';
        
        // Remove qualquer formatação existente
        const digitsOnly = cardNumber.toString().replace(/\D/g, '');
        
        // Pega no máximo os últimos 4 dígitos
        const lastFour = digitsOnly.slice(-4);
        
        return `•••• •••• •••• ${lastFour}`;
    };
    
    const getIcon = (iconName) => {
        if (!iconName) return ['fas', 'th'];
        const parts = iconName.split(' ');
        if (parts.length === 2) {
            return parts;
        }
        return ['fas', 'th'];
    };

    // Função para gerar senha aleatória
    const generateRandomPassword = () => {
        const length = 12;
        const charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*()_+~`|}{[]:;?><,./-=";
        let password = "";
        for (let i = 0; i < length; i++) {
        password += charset.charAt(Math.floor(Math.random() * charset.length));
        }
        return password;
    };
    
    // Estado para controlar a visibilidade da senha
    const [showPassword, setShowPassword] = useState(false);

    const fetchRegistrosDoGrupo = async (grupoId) => {
        const token_autorizado = getCookie("info");
    
        try {
            const token_autorizado = getCookie("info");
    
            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/grupos/buscar_registros_por_grupo`, {
                method: 'POST',
                headers: {
                    'Authority': token_autorizado,
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ grupo_id: grupoId }),
            });
    
            const result = await response.json();
    
            if (result.status === "ok") {
                setSelectedGrupoDetalhes(prev => ({
                    ...prev,
                    registros: result.registros, // Atualiza os registros do grupo selecionado
                    opcaoEdicao: result.opcaoEdicao
                }));        
            } else {
                showToast(result.mensagem, "error");
            }
        } catch (error) {
            console.error(error);
            showToast("Erro ao buscar registros. Tente novamente mais tarde.", "error");
        }
    };
    
    const handleAddRecord = () => {
        setIsEditing(false);
        setNewRecord({ titulo: '', login: '', sistemaTipo: 'URL', sistemaValor: '', notas: '' });
        setSistemaTipoSelecionado('URL'); // Resetar o dropdown para "URL"
        setShowAddRecordFormOnly(true);
    };
    
    const handleCancelAddRecord = () => {
        setShowAddRecordFormOnly(false);
        setNewRecord({ titulo: '', login: '', sistemaTipo: 'URL', sistemaValor: '', notas: '' });
        setSistemaTipoSelecionado('URL'); // Resetar o dropdown para "URL"
        setIsEditing(false);
    };

    const handleSaveRecord = async () => {
        if (!selectedGrupoDetalhes) return;
    
        const isCartao = newRecord.sistemaTipo === 'Cartão';
        const cardBrand = isCartao ? detectCardBrand(newRecord.numeroCartao) : '';
        const cardTypeFormatted = isCartao ? 
            (cardBrand === 'mastercard' ? 'Mastercard' : 
             cardBrand === 'visa' ? 'Visa' : 
             cardBrand === 'elo' ? 'Elo' : 'Outro') : '';
    
        const formattedCPF = isCartao ? formatCPF(newRecord.cpfCnpj) : null;
    
        const registroData = {
            grupo_id: selectedGrupoDetalhes.id,
            titulo: newRecord.titulo,
            op_sistema: isCartao ? 'cartao' : newRecord.sistemaTipo.toLowerCase(),
            btn_sistema: isCartao ? 'Cartão' : newRecord.sistemaTipo,
            notas: newRecord.notas || null
        };
    
        if (isCartao) {
            Object.assign(registroData, {
                numero: newRecord.numeroCartao,
                cpf: formattedCPF,
                nome: newRecord.nomeCartao || null,
                senha: newRecord.senha,
                mes: newRecord.mesVencimento,
                ano: newRecord.anoVencimento,
                codigo_cartao: newRecord.cvv,
                icon: cardBrand || 'default',
                sistema: cardTypeFormatted
            });
    
            if (!newRecord.anoVencimento || newRecord.anoVencimento.length !== 4) {
                showToast('O ano de vencimento deve ter 4 dígitos', 'error');
                return;
            }
    
            if (!newRecord.numeroCartao || newRecord.numeroCartao.replace(/\D/g, '').length < 13) {
                showToast('Número do cartão inválido', 'error');
                return;
            }
    
        } else {
            Object.assign(registroData, {
                login: newRecord.login || null,
                senha: newRecord.senha,
                sistema: newRecord.sistemaValor || null,
                nome_arquivo: newRecord.arquivo || null,
                hash_arquivo: hashArquivo
            });
        }
    
        const token_autorizado = getCookie("info");
    
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/registros/cadastrar`, {
                method: 'POST',
                headers: {
                    'Authority': token_autorizado,
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(registroData),
            });
    
            const result = await response.json();
    
            if (result.status === "erro") {
                showToast(result.mensagem, 'error');
                return;
            }
    
            if (newRecord.arquivo) {
                saveFileMetadata(result._id || result.id, newRecord.arquivo);
            }
    
            // Atualiza registros do grupo após salvar com sucesso
            await fetchRegistrosDoGrupo(selectedGrupoDetalhes.id);
    
            // Reseta o formulário
            setShowAddRecordFormOnly(false);
            setNewRecord({ 
                titulo: '', 
                login: '', 
                sistemaTipo: 'URL', 
                sistemaValor: '', 
                notas: '', 
                arquivo: null,
                numeroCartao: '',
                cpfCnpj: '',
                nomeCartao: '',
                mesVencimento: '',
                anoVencimento: '',
                cvv: '',
                senha: ''
            });
    
            showToast('Registro adicionado com sucesso!', 'success');
    
        } catch (error) {
            console.error('Erro:', error);
            showToast(error.mensagem || 'Erro ao adicionar registro', 'error');
        }
    };


    const handleNewRecordChange = (e) => {
        const { name, value } = e.target;
        setNewRecord(prev => ({
            ...prev,
            [name]: value
        }));
        
        // Detecta a bandeira do cartão quando o número muda
        if (name === 'numeroCartao') {
            detectCardBrand(value);
        }
    };

    const handleUpdateRecord = async () => {
        if (!editingRecord) return;
    
        const isCartao = newRecord.sistemaTipo === 'Cartão';
        const registroId = editingRecord._id || editingRecord.id;
        const grupoId = selectedGrupoDetalhes.id;
        const cardBrand = isCartao ? detectCardBrand(newRecord.numeroCartao) : null;
        const cardTypeFormatted = isCartao ? 
            (cardBrand === 'mastercard' ? 'Mastercard' : 
             cardBrand === 'visa' ? 'Visa' : 
             cardBrand === 'elo' ? 'Elo' : 'Outro') : null;
    
        const registroData = {
            id: registroId,
            id_grupo: grupoId,
            titulo: newRecord.titulo,
            notas: newRecord.notas,
            op_sistema: isCartao ? 'cartao' : newRecord.sistemaTipo.toLowerCase(),
            btn_sistema: isCartao ? 'Cartão' : newRecord.sistemaTipo
        };
    
        if (isCartao) {
            Object.assign(registroData, {
                numero: newRecord.numeroCartao,
                cpf: newRecord.cpfCnpj,
                nome: newRecord.nomeCartao,
                senha: newRecord.senha,
                mes: newRecord.mesVencimento,
                ano: newRecord.anoVencimento,
                codigo_cartao: newRecord.cvv,
                icon: cardBrand || editingRecord.icon || 'default',
                sistema: cardTypeFormatted
            });
        } else {
            Object.assign(registroData, {
                login: newRecord.login,
                senha: newRecord.senha,
                sistema: newRecord.sistemaValor,
                nome_arquivo: newRecord.arquivo || null,
                hash_arquivo: hashArquivo || null
            });
        }
    
        const token_autorizado = getCookie("info");
    
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/registros/atualizar`, {
                method: 'POST',
                headers: {
                    'Authority': token_autorizado,
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(registroData),
            });
    
            if (!response.ok) throw new Error('Erro na requisição');
            
            const result = await response.json();
    
            if (result.status === "erro") {
                showToast(result.mensagem, 'error');
                return;
            }

            await fetchRegistrosDoGrupo(grupoId);
    
            // Reseta o formulário
            setShowAddRecordFormOnly(false);
            setIsEditing(false);
            setNewRecord({
                titulo: '',
                login: '',
                senha: '',
                sistemaTipo: 'URL',
                sistemaValor: '',
                notas: '',
                arquivo: null,
                numeroCartao: '',
                cpfCnpj: '',
                nomeCartao: '',
                mesVencimento: '',
                anoVencimento: '',
                cvv: ''
            });
    
            showToast('Registro atualizado com sucesso!', 'success');
    
        } catch (error) {
            console.error('Erro:', error);
            showToast('Erro ao atualizar registro', 'error');
        }
    };

    // const handleUpdateRecord = async () => {
    //     if (!editingRecord) return;
    
    //     const isCartao = newRecord.sistemaTipo === 'Cartão';
    //     const registroId = editingRecord._id || editingRecord.id;
    //     const grupoId = selectedGrupoDetalhes.id;
    //     const cardBrand = isCartao ? detectCardBrand(newRecord.numeroCartao) : null;
    //     const cardTypeFormatted = isCartao ? 
    //         (cardBrand === 'mastercard' ? 'Mastercard' : 
    //          cardBrand === 'visa' ? 'Visa' : 
    //          cardBrand === 'elo' ? 'Elo' : 'Outro') : null;
    
    //     const registroData = {
    //         id: registroId,
    //         id_grupo: grupoId,
    //         titulo: newRecord.titulo,
    //         notas: newRecord.notas,
    //         op_sistema: isCartao ? 'cartao' : newRecord.sistemaTipo.toLowerCase(),
    //         btn_sistema: isCartao ? 'Cartão' : newRecord.sistemaTipo
    //     };
    
    //     if (isCartao) {
    //         Object.assign(registroData, {
    //             numero: newRecord.numeroCartao,
    //             cpf: newRecord.cpfCnpj,
    //             nome: newRecord.nomeCartao,
    //             senha: newRecord.senha,
    //             mes: newRecord.mesVencimento,
    //             ano: newRecord.anoVencimento,
    //             codigo_cartao: newRecord.cvv,
    //             icon: cardBrand || editingRecord.icon || 'default',
    //             sistema: cardTypeFormatted
    //         });
    //     } else {
    //         Object.assign(registroData, {
    //             login: newRecord.login,
    //             senha: newRecord.senha,
    //             sistema: newRecord.sistemaValor,
    //             nome_arquivo: newRecord.arquivo,
    //             hash_arquivo: hashArquivo
    //         });
    //     }
    
    //     const token_autorizado = getCookie("info");
    
    //     fetch(`${process.env.REACT_APP_API_URL}/api/registros/atualizar`, {
    //         method: 'POST',
    //         headers: {
    //             'Authority': token_autorizado,
    //             'Accept': 'application/json',
    //             'Content-Type': 'application/json',
    //         },
    //         body: JSON.stringify(registroData),
    //     })
    //     .then(response => {
    //         if (!response.ok) throw new Error('Erro na requisição');
    //         return response.json();
    //     })
    //     .then(result => {
    //         if (result.status === "erro") {
    //             showToast(result.mensagem, 'error');
    //         } else {
    //             // Atualiza o estado local
    //             const updatedRegistros = selectedGrupoDetalhes.registros.map(r => {
    //                 if (r._id === registroId || r.id === registroId) {
    //                     const updated = { 
    //                         ...r, 
    //                         titulo: newRecord.titulo,
    //                         notas: newRecord.notas,
    //                         opcao_sistema: isCartao ? 'cartao' : newRecord.sistemaTipo.toLowerCase(),
    //                         arquivo: newRecord.arquivo
    //                     };
                        
    //                     if (isCartao) {
    //                         Object.assign(updated, {
    //                             numero: newRecord.numeroCartao,
    //                             cpf: newRecord.cpfCnpj,
    //                             nome: newRecord.nomeCartao,
    //                             senha: newRecord.senha,
    //                             mes: newRecord.mesVencimento,
    //                             ano: newRecord.anoVencimento,
    //                             codigo_cartao: newRecord.cvv,
    //                             sistema: cardTypeFormatted,
    //                             icon: cardBrand || r.icon || 'default'
    //                         });
    //                     } else {
    //                         Object.assign(updated, {
    //                             login: newRecord.login,
    //                             senha: newRecord.senha,
    //                             sistema: newRecord.sistemaValor
    //                         });
    //                     }
    //                     return updated;
    //                 }
    //                 return r;
    //             });
    
    //             const updatedGroup = {
    //                 ...selectedGrupoDetalhes,
    //                 registros: updatedRegistros
    //             };
    
    //             setSelectedGrupoDetalhes(updatedGroup);
    //             setGrupos(grupos.map(g => 
    //                 g.id === grupoId ? updatedGroup : g
    //             ));
    
    //             // Reseta o formulário
    //             setShowAddRecordFormOnly(false);
    //             setIsEditing(false);
    //             setNewRecord({
    //                 titulo: '',
    //                 login: '',
    //                 senha: '',
    //                 sistemaTipo: 'URL',
    //                 sistemaValor: '',
    //                 notas: '',
    //                 arquivo: null,
    //                 numeroCartao: '',
    //                 cpfCnpj: '',
    //                 nomeCartao: '',
    //                 mesVencimento: '',
    //                 anoVencimento: '',
    //                 cvv: ''
    //             });
    
    //             showToast('Registro atualizado com sucesso!', 'success');
    //         }

           
    //     })
    //     .catch(error => {
    //         console.error('Erro:', error);
    //         showToast('Erro ao atualizar registro', 'error');
    //     });
    // };

    const handleBackToRecords = () => {
        setShowAddRecordFormOnly(false);
        setIsEditing(false);
        setNewRecord({ titulo: '', login: '', senha: '', sistemaTipo: 'URL', sistemaValor: '', notas: '' });
        //setSistemaTipoSelecionado('URL'); 
    };

    const handleEditRecord = (registro) => {
        const isCartao = registro.opcao_sistema === 'cartao';

        setSistemaTipoSelecionado(isCartao ? 'Cartão' : registro.opcao_sistema || 'URL');
        
        if (isCartao) {
            setNewRecord({
                titulo: registro.titulo,
                sistemaTipo: 'Cartão',
                numeroCartao: registro.numero || '',
                cpfCnpj: registro.cpf || '',
                nomeCartao: registro.nome || '',
                mesVencimento: registro.mes || '',
                anoVencimento: registro.ano || '',
                cvv: registro.codigo_cartao || '',
                senha: '', // Não preencher a senha por segurança
                notas: registro.notas || '',
                icon: registro.icon || 'default'
            });
            // Atualiza o cardType visual
            if (registro.sistema) {
                setCardType(registro.sistema);
                setCardIcon(
                    registro.sistema.toLowerCase() === 'visa' ? visaIcon :
                    registro.sistema.toLowerCase() === 'mastercard' ? mastercardIcon :
                    registro.sistema.toLowerCase() === 'elo' ? eloIcon :
                    defaultIcon
                );
            }
        } else {

            setNewRecord(prev => ({
                ...prev,
                titulo: registro.titulo,
                login: registro.login || '',
                senha: '',
                sistemaTipo: registro.opcao_sistema || 'URL',
                sistemaValor: registro.sistema || '',
                notas: registro.notas || '',
                arquivo: registro.nome_arquivo || null 
            }));
        }
    
        setIsEditing(true);
        setEditingRecord(registro);
        setShowAddRecordFormOnly(true);

        setNewRecord(prev => ({
            ...prev,
            arquivo: registro.nome_arquivo || null
        }));
    };
    
    const handleDeleteRecord = (registro) => {
        // const absoluteIndex = (currentPage - 1) * recordsPerPage + index;
        // const registro = selectedGrupoDetalhes.registros[absoluteIndex];
        
        if (!registro) {
            showToast('Erro: Registro não encontrado', 'error');
            return;
        }
    
        //setRecordToDelete({ index: absoluteIndex, registro });
        setRecordToDelete(registro);
        setShowDeleteConfirmation(true);
    };

    const confirmDelete = async () => {
        // if (!recordToDelete || !recordToDelete.registro._id) {
        //     showToast('Erro: ID do registro inválido', 'error');
        //     setShowDeleteConfirmation(false);
        //     return;
        // }

        if (!recordToDelete) {
            showToast('Erro: Registro inválido', 'error');
            setShowDeleteConfirmation(false);
            return;
        }
    
        try {
            const token_autorizado = getCookie("info");
            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/registros/deletar`, {
                method: 'POST',
                headers: {
                    'Authority': token_autorizado,
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    //id: recordToDelete.registro._id,  // Agora usando _id
                    id: recordToDelete._id,
                    id_grupo: selectedGrupoDetalhes.id
                }),
            });
    
            const result = await response.json();
    
            if (result.status === "ok") {

                // Atualiza o estado
                // const updatedRegistros = selectedGrupoDetalhes.registros.filter(
                //     (_, i) => i !== recordToDelete.index
                // );
                const updatedRegistros = selectedGrupoDetalhes.registros.filter(
                    (r) => r._id !== recordToDelete._id 
                );
                
                setSelectedGrupoDetalhes(prev => ({
                    ...prev,
                    registros: updatedRegistros
                }));
    
                setGrupos(prev => prev.map(grupo => 
                    grupo.id === selectedGrupoDetalhes.id
                        ? { ...grupo, registros: updatedRegistros }
                        : grupo
                ));
    
                showToast('Registro excluído com sucesso!', 'success');
            } else {
                showToast(result.mensagem || 'Erro ao excluir registro', 'error');
            }
        } catch (error) {
            console.error('Erro ao excluir registro:', error);
            showToast('Erro ao excluir registro', 'error');
        } finally {
            setShowDeleteConfirmation(false);
            setRecordToDelete(null);
        }
    };
/// ------------------------------------ SENHA --------------------------------------------------- ///
    const fetchSenhaDescriptografada = async (registroId, isCartao = false) => {
        setLoadingSenha(true);
        try {
            const token_autorizado = getCookie("info");
            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/registros/verChave?id=${registroId}&opcao=${isCartao ? 'visualizar_cartao' : 'visualizar_senha'}`, {
                headers: {
                    'Authority': token_autorizado,
                },
            });

            if (!response.ok) {
                throw new Error(`Erro HTTP: ${response.status}`);
            }

            const result = await response.json();
            
            if (result.status === "ok") {
                if (isCartao) {
                    if (isEncrypted(result.registro.cvv)) {
                        throw new Error('Dados ainda criptografados recebidos do backend');
                    }
                    
                    const cartaoCompleto = {
                        ...result.registro,
                        cvv: result.registro.cvv || '•••'
                    };
                    
                    setCartaoSelecionado(cartaoCompleto);
                    setShowCartaoModal(true);
                    setAcessoVerificado(false);
                } else {
                    if (result.chave == null) {
                        showToast('Este registro não possui senha', 'error');
                        return;
                    }
                    return result.chave;
                }
            } else if (result.status === "bloqueado") {
                setShowVerificarAcessoModal(true);
            
            } else if (result.status === "erro") {
                throw new Error(result.mensagem || 'Erro no servidor');
            }
        } catch (error) {
            console.error('Erro ao buscar dados do cartão:', error);
            showToast(error.message || 'Erro ao visualizar cartão', 'error');
            
            // Mostra modal de erro com detalhes para debug
            setCartaoSelecionado({
                titulo: "Erro",
                erro: error.message,
                dadosRecebidos: error.response ? await error.response.json() : null
            });
            
        } finally {
            setLoadingSenha(false);
        }
    };

    // Função auxiliar para detectar se um valor está criptografado
    function isEncrypted(value) {
        return typeof value === 'string' && value.startsWith('gAAAAAB');
    }

    /// ----------------------------------- FAVORITOS -----------------------------------------------///
    const fetchFavoritos = async () => {
        try {
            const token_autorizado = getCookie("info");
            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/registros/buscar_favoritos`, {
                method: 'POST',
                headers: {
                    'Authority': token_autorizado,
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
            });
            
            const result = await response.json();
            if (result.status === "ok") {
                return result.lista;
            }
            return [];
        } catch (error) {
            console.error('Erro ao buscar favoritos:', error);
            return [];
        }
    };
    
    const toggleFavorito = async (index) => {
        const absoluteIndex = (currentPage - 1) * recordsPerPage + index;
        const registro = selectedGrupoDetalhes.registros[absoluteIndex];
        const registroId = registro._id || registro.id;
        const usuarioId = getCookie("info").id;
        const isFavorito = registro.favorito === "fas fa-star text-warning";
    
        try {
            const token_autorizado = getCookie("info");
            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/registros/registro_favorito`, {
                method: 'POST',
                headers: {
                    'Authority': token_autorizado,
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    opcao: isFavorito ? "desfavoritar" : "favoritar",
                    id: registroId
                }),
            });
    
            const result = await response.json();
            if (result.status === "ok") {
                // Atualiza o estado local conforme o formato do backend
                const updatedRegistros = selectedGrupoDetalhes.registros.map(r => {
                    if ((r._id === registroId || r.id === registroId)) {
                        return { 
                            ...r, 
                            favorito: isFavorito ? "far fa-star" : "fas fa-star text-warning"
                        };
                    }
                    return r;
                });
    
                const updatedGroup = {
                    ...selectedGrupoDetalhes,
                    registros: updatedRegistros
                };
    
                setSelectedGrupoDetalhes(updatedGroup);
                setGrupos(grupos.map(g => g.id === selectedGrupoDetalhes.id ? updatedGroup : g));
                
                showToast(isFavorito ? 'Registro removido dos favoritos' : 'Registro adicionado aos favoritos', 'success');
            } else {
                showToast(result.mensagem || 'Erro ao atualizar favorito', 'error');
            }
        } catch (error) {
            console.error('Erro ao atualizar favorito:', error);
            showToast('Erro ao atualizar favorito', 'error');
        }
    };

    const handleShowOrCopyPassword = async (registro, copiar = false) => { 

        const isCartao = registro.opcao_sistema === 'cartao';

        // Se for cartão e ainda não verificou o acesso, exibe o modal e aguarda
        if (isCartao && !acessoVerificadoRef.current) {
            setRegistroSelecionado(registro);
            setAcaoPendente(() => () => handleShowOrCopyPassword(registro, copiar)); // Guarda ação para depois
            setShowVerificarAcessoModal(true); // Mostra modal
            return;
        }

        if (copiar) {

            if (isCartao) {
                showToast('Não é possível copiar dados de cartão', 'warning');
                return;
            }

            setLoadingSenha(true);

            try {

                const senhaDescriptografada = await fetchSenhaDescriptografada(registro._id || registro.id); 

                if (senhaDescriptografada) {
                    navigator.clipboard.writeText(senhaDescriptografada).then(() => {
                        setShowCopySuccess(true);
                        setShowPasswordPopup(false);
                        setTimeout(() => setShowCopySuccess(false), 3000);
                    });
                }
                else{
                    setShowPasswordPopup(false);
                }
            } finally {
                setLoadingSenha(false);
            }

        } else{

            setRegistroSelecionado(registro);

            if (isCartao) {

                await fetchSenhaDescriptografada(registro._id || registro.id, true);
                setShowCartaoModal(true);

            } else {
                // Para registros normais, mostra apenas a senha
                const senhaDescriptografada = await fetchSenhaDescriptografada(registro._id || registro.id);
                if (senhaDescriptografada) {
                    setPasswordToShow(senhaDescriptografada);
                    setShowPasswordPopup(true);
                }
            }
            setCopiarChave(false);
        }  
    };

    useEffect(() => {
        if (showPasswordPopup) {
            const timer = setTimeout(() => {
                setShowPasswordPopup(false);
            }, 15000); // 10000 ms = 10 segundos
    
            // Limpa o timer se o componente desmontar ou se showPasswordPopup mudar
            return () => clearTimeout(timer);
        }
    }, [showPasswordPopup]);

/// ------------------------------------ DONWLOAD DE ARQUIVOS -----------------------------------///
    // Função para salvar arquivo no localStorage
    const saveFileMetadata = (registroId, file) => {
        const fileData = {
            name: file.name,
            type: file.type,
            size: file.size,
            lastModified: file.lastModified
        };
        localStorage.setItem(`file_${registroId}`, JSON.stringify(fileData));
    };
    
    const getFileMetadata = (registroId) => {
        const fileData = localStorage.getItem(`file_${registroId}`);
        return fileData ? JSON.parse(fileData) : null;
    };

    const [cardIcon, setCardIcon] = useState(defaultIcon);

    const detectCardBrand = (cardNumber) => {
        if (!cardNumber) return 'outro';
        
        const cleaned = cardNumber.replace(/\s+/g, '');
        
        if (/^4/.test(cleaned)) {
            setCardType('Visa');
            setCardIcon(visaIcon);
            return 'visa';
        } else if (/^5[1-5]/.test(cleaned)) {
            setCardType('Mastercard');
            setCardIcon(mastercardIcon);
            return 'mastercard';
        } else if (/^4011|^4312|^4389|^4514|^4573|^5067|^5090|^6277|^6363/.test(cleaned)) {
            setCardType('Elo');
            setCardIcon(eloIcon);
            return 'elo';
        } else {
            setCardType('Outro');
            setCardIcon(defaultIcon);
            return 'outro';
        }
    };
   
    /// ------------------------------------ UPLOAD DE ARQUIVO -----------------------------------///  
    const handleFileChange = (e) => {
        if (fileInputRef.current) {
            fileInputRef.current.value = '';
        }

        setUploadError('Upload de arquivos temporariamente indisponível.');
        setFileErrorTrigger(prev => prev + 1);
        setArquivo(null);
        setHashArquivo(null);
    };

/// ------------------------------------ HISTORICO -----------------------------------///  
    const fetchHistorico = async (registroId) => {
        setLoadingHistorico(true);
        try {
            const token_autorizado = getCookie("info");
            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/registros/buscar?id=${registroId}`, {
                headers: {
                    'Authority': token_autorizado,
                },
            });

            if (!response.ok) {
                throw new Error(`Erro HTTP: ${response.status}`);
            }

            const result = await response.json();
            
            if (result.status === "ok" && result.historico) {
                setHistorico(result.historico);
            } else {
                setHistorico([]);
                showToast(result.mensagem || 'Nenhum histórico encontrado', 'info');
            }
        } catch (error) {
            console.error('Erro ao buscar histórico:', error);
            showToast('Erro ao carregar histórico', 'error');
            setHistorico([]);
        } finally {
            setLoadingHistorico(false);
        }
    };

    useEffect(() => {
        if (editingRecord && editingRecord.numeroCartao) {
            detectCardBrand(editingRecord.numeroCartao);
        }
    }, [editingRecord]);

    useEffect(() => {
        
        if (selectedGrupoDetalhes && selectedGrupoDetalhes.registros) {
            selectedGrupoDetalhes.registros.forEach(registro => {
                if (registro.opcao_sistema === 'cartao' && registro.numero) {
                    detectCardBrand(registro.numero);
                }
            });
        }
    }, [selectedGrupoDetalhes]);

    // 
    const downloadArquivoComNome = async (url, novoNome) => {
        try {

            const response = await fetch(url);
            if (!response.ok) {
                throw new Error("Erro ao buscar o arquivo");
            }

            const blob = await response.blob();
            const blobUrl = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = blobUrl;
            link.download = novoNome; // Nome personalizado
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(blobUrl); // Limpa o objeto blob da memória
        } catch (error) {
            console.error("Falha no download:", error);
            alert("Erro ao baixar o arquivo.");
        }
    };

    const verificarCodigo = (codigo, fecharModal, setIsLoading) => {
        const registro = registroSelecionado;
        
        validarOTP(
            codigo,
            "validacao",
            async () => {
                fecharModal();
                setAcessoVerificado(true);
                setIsLoading(false);
                
                if(copiarChave) {
                    handleShowOrCopyPassword(registro, true);
                }
                else {
                    handleShowOrCopyPassword(registro);
                }
                
                
                
                if (acaoPendente) {
                    await acaoPendente(); // Executa ação guardada
                    setAcaoPendente(null);
                }
            },
            () => {}, // erro
            setIsLoading
        );
    };

    const cancelarVerificacao = () => {
        setShowVerificarAcessoModal(false);
        setRegistroSelecionado(null);
        setAcaoPendente(null);
        setAcessoVerificado(false);
    };

    return (
        <>
            {showPasswordPopup && (
                <>
                    <div className="password-popup-overlay"></div>
                    <div className='password-popup'>
                        <div className='password-timer-bar' /> 
                        <div className='password-popup-content'>
                            <p>{passwordToShow}</p>
                            <div className='password-popup-buttons'>
                                <button
                                    className='btn-copy'
                                    onClick={() => {
                                        navigator.clipboard.writeText(passwordToShow).then(() => {
                                            setShowCopySuccess(true);
                                            setShowPasswordPopup(false);
                                            setTimeout(() => setShowCopySuccess(false), 3000);
                                        });
                                    }}
                                >
                                    Copiar
                                </button>
                                <button
                                    className='btn-close'
                                    onClick={() => setShowPasswordPopup(false)}
                                >
                                    Fechar
                                </button>
                            </div>
                        </div>
                    </div>
                </>
            )}

            {showCopySuccess && (
                <div className="password-popup-overlay">
                    <div className="password-popup">
                        <div className="password-popup-content">
                            <img src={checklistGif} alt="Confirmação" style={{ width: '80px', height: '80px' }} />
                            <p>Senha copiada com sucesso!</p>
                        </div>
                    </div>
                </div>
            )}

            {showAddRecordFormOnly ? (
                <section className="add-record-form">
                    <div className="header-right">
                        <button className="btn-back" onClick={handleBackToRecords}>
                            <FontAwesomeIcon icon={faChevronLeft} />
                        </button>
                        <h2>{isEditing ? 'Editar Registro' : 'Adicionar Registro'}</h2>
                    </div>
                    <h3 style={{ color: '#f0f0f0' }}>{isEditing ? '' : 'Novo Registro'}</h3>
                    
                    <div className="form-group">
                        <label>Título</label>
                        <input
                            type="text"
                            name="titulo"
                            value={newRecord.titulo}
                            onChange={(e) => {
                                if (e.target.value.length > 50) {
                                    showToast("Título não pode ter mais de 50 caracteres", "warning");
                                    return;
                                }
                                handleNewRecordChange(e);
                            }}
                        />
                    </div>
                    
                    {sistemaTipoSelecionado === 'Cartão' ? (
                        <>
                            <div className="form-group">
                                <label>Número do Cartão</label>
                                <div className="card-number-input">
                                    <input
                                        type="text"
                                        name="numeroCartao"
                                        value={newRecord.numeroCartao}
                                        onChange={(e) => {
                                            if (e.target.value.length > 16) {
                                                showToast("Número do cartão não pode ter mais de 16 dígitos", "warning");
                                                return;
                                            }
                                            handleNewRecordChange(e);
                                            detectCardBrand(e.target.value);
                                        }}
                                    />
                                    <img
                                        src={cardIcon}
                                        alt="Bandeira do Cartão"
                                        className="card-icon"
                                    />
                                </div>
                            </div>
                            
                            <div className="form-group">
                                <label>CPF/CNPJ</label>
                                <input
                                    type="text"
                                    name="cpfCnpj"
                                    value={newRecord.cpfCnpj || ''}
                                    onChange={(e) => {
                                        if (e.target.value.length > 14) {
                                            showToast("Este campo não pode ter mais de 14 dígitos", "warning");
                                            return;
                                        }handleNewRecordChange(e);
                                    }}

                                    required
                                />
                            </div>
                            
                            <div className="form-group">
                                <label>Nome no Cartão</label>
                                <input
                                    type="text"
                                    name="nomeCartao"
                                    value={newRecord.nomeCartao}
                                    onChange={(e) => {
                                        if (e.target.value.length > 50) {
                                            showToast("Nome não pode ter mais de 50 dígitos", "warning");
                                            return;
                                        }handleNewRecordChange(e);
                                    }}
                                />
                            </div>
                            
                            <div className="form-group">
                                <label>Senha</label>
                                <div className="password-input-container">
                                    <input
                                    type={showPassword ? "text" : "password"}
                                    name="senha"
                                    value={newRecord.senha}
                                    onChange={(e) => {
                                        if (e.target.value.length > 80) {
                                            showToast("Senha não pode ter mais de 80 dígitos", "warning");
                                            return;
                                        }handleNewRecordChange(e);
                                    }}
                                    />
                                    <div className="password-buttons">
                                   
                                    <button
                                        type="button"
                                        className="password-toggle"
                                        onClick={() => setShowPassword(!showPassword)}
                                        title={showPassword ? "Ocultar senha" : "Mostrar senha"}
                                    >
                                        <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
                                    </button>
                                    </div>
                                </div>
                            </div>
                            
                            <div className="form-group-small">
                                <div className="form-group">
                                    <label>Mês</label>
                                    <input
                                        type="text"
                                        name="mesVencimento"
                                        value={newRecord.mesVencimento}
                                        onChange={(e) => {
                                            if (e.target.value.length > 2) {
                                                showToast("Mês não pode ter mais de 2 dígitos", "warning");
                                                return;
                                            }handleNewRecordChange(e);
                                        }}
                                        className="small-input"
                                        placeholder="MM"
                                    />
                                </div>
                                
                                <div className="form-group">
                                    <label>Ano</label>
                                    <input
                                        type="text"
                                        name="anoVencimento"
                                        value={newRecord.anoVencimento}
                                        onChange={(e) => {
                                        // Permite apenas números e limita a 4 dígitos
                                        const value = e.target.value.replace(/\D/g, '').slice(0, 4);
                                        setNewRecord(prev => ({ ...prev, anoVencimento: value }));
                                        }}
                                        className="small-input"
                                        placeholder="AAAA"
                                        maxLength="4"
                                        required
                                    />
                                    </div>
                                
                                <div className="form-group">
                                    <label>CVV</label>
                                    <input
                                        type="text"
                                        name="cvv"
                                        value={newRecord.cvv}
                                        onChange={(e) => {
                                            if (e.target.value.length > 3) {
                                                showToast("CVV não pode ter mais de 3 dígitos", "warning");
                                                return;
                                            }handleNewRecordChange(e);
                                        }}
                                        className="small-input"
                                        placeholder="123"
                                    />
                                </div>
                            </div>
                            
                            
                            <div className="form-group">
                                <label>Notas</label>
                                <input
                                    type="text"
                                    name="notas"
                                    value={newRecord.notas}
                                    onChange={(e) => {
                                            if (e.target.value.length > 80) {
                                                showToast("CVV não pode ter mais de 80 dígitos", "warning");
                                                return;
                                            }handleNewRecordChange(e);
                                        }}
                                    placeholder="Observações adicionais"
                                />
                            </div>
                        </>
                        
                    ) : (
                        <>
                            <div className="form-group">
                                <label>Login</label>
                                <input
                                    type="text"
                                    name="login"
                                    value={newRecord.login}
                                    onChange={(e) => {
                                        if (e.target.value.length > 50) {
                                            showToast("Login não pode ter mais de 50 caracteres", "warning");
                                            return;
                                        }
                                        handleNewRecordChange(e);
                                    }}
                                />
                            </div>
                            <div className="form-group">
                                <label>Senha</label>
                                <div className="password-input-container">
                                    <input
                                    type={showPassword ? "text" : "password"}
                                    name="senha"
                                    value={newRecord.senha}
                                    onChange={(e) => {
                                        if (e.target.value.length > 250) {
                                            showToast("Senha não pode ter mais de 250 caracteres", "warning");
                                            return;
                                        }
                                        handleNewRecordChange(e);
                                    }}
                                  
                                    />
                                    <div className="password-buttons">
                                    <button
                                        type="button"
                                        className="password-generate"
                                        onClick={() => {
                                        setNewRecord(prev => ({ ...prev, senha: generateRandomPassword() }));
                                        }}
                                        title="Gerar senha aleatória"
                                    >
                                        <FontAwesomeIcon icon={faKey} />
                                    </button>
                                    <button
                                        type="button"
                                        className="password-toggle"
                                        onClick={() => setShowPassword(!showPassword)}
                                        title={showPassword ? "Ocultar senha" : "Mostrar senha"}
                                    >
                                        <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
                                    </button>
                                    </div>
                                </div>
                                </div>
                            <div className="form-group sistema-container">
                                <label className="sistema-label">Sistema</label>
                                <div className="sistema-input-group">
                                    <select
                                        name="sistemaTipo"
                                        value={newRecord.sistemaTipo}
                                        onChange={(e) => {
                                            setNewRecord(prev => ({ ...prev, sistemaTipo: e.target.value }));
                                            setSistemaTipoSelecionado(e.target.value);
                                        }}
                                        className="dropdown-small"
                                        style={{ textAlign: 'left' }}
                                        required 
                                    >
                                        <option value="URL">URL</option>
                                        <option value="IP">IP</option>
                                        <option value="RDP">RDP</option>
                                        <option value="SSH">SSH</option>
                                        <option value="Cartão">Cartão</option>
                                        <option value="Outros">Outros</option>
                                    </select>
                                    <input
                                        type="text"
                                        name="sistemaValor"
                                        value={newRecord.sistemaValor}
                                        onChange={(e) => {
                                            if (e.target.value.length > 50) {
                                                showToast("Sistema não pode ter mais de 50 caracteres", "warning");
                                                return;
                                            }
                                            setNewRecord(prev => ({ ...prev, sistemaValor: e.target.value }))}}
                                        placeholder="Digite o sistema"
                                        className="sistema-input"
                                    />
                                </div>
                            </div>
                            <div className="form-group">
                                <label>Notas</label>
                                <input
                                    type="text"
                                    name="notas"
                                    value={newRecord.notas}
                                    onChange={(e) => {
                                        if (e.target.value.length > 500) {
                                            showToast("Notas não podem ter mais de 500 caracteres", "error");
                                            return;
                                        }
                                        handleNewRecordChange(e);
                                    }} 
                                />
                            </div>
                            <div className="form-group upload-group">
                                <label>Arquivo</label>
                                <div className="upload-container">
                                    {newRecord.arquivo ? (
                                        <div className="arquivo-container">
                                            <span
                                                className="arquivo-link"
                                            >
                                                {newRecord.arquivo}
                                            </span>
                                            <span
                                                className="btn-cancel-upload"
                                                onClick={() => {
                                                    setNewRecord({ ...newRecord, arquivo: null }); // Remove o arquivo
                                                }}
                                            >
                                                &times; {/* Isso exibe um "X" */}
                                            </span>
                                        </div>
                                    ) : (
                                        <div className="file-upload">
                                            <label htmlFor="fileInput" className="file-label">  
                                                <FontAwesomeIcon icon={faFile} style={{ marginRight: '6px' }} />
                                                {loading ? 'Carregando...' : 'Escolher Arquivo'}
                                            </label>
                                            <small 
                                                key={`file-size-${fileErrorTrigger}`} // Key única para forçar recriação
                                                className="file-size-info"
                                                style={{
                                                    display: 'block',
                                                    marginTop: '4px',
                                                    color: '#888',
                                                    animation: fileErrorTrigger > 0 ? 'flashRed 0.5s ease 3' : 'none'
                                                }}
                                            >
                                                Tamanho máximo: 5MB
                                            </small>
                                            <input 
                                                type="file" 
                                                id="fileInput" 
                                                ref={fileInputRef}
                                                onChange={handleFileChange} 
                                                className="hidden-file-input" 
                                            />
                                            {uploadError && <span className="upload-error">{uploadError}</span>}
                                        </div>
                                    )}
                                </div>
                                <input
                                    type="file"
                                    id="fileInput"
                                    onChange={(e) => {
                                        const file = e.target.files[0];
                                        if (file) {
                                        setNewRecord(prev => ({ ...prev, arquivo: file.name }));
                                        }
                                    }}
                                    className="hidden-file-input"
                                />
                            </div>
                        </>
                    )}
                    <div className="button-group">
                        <button onClick={isEditing ? handleUpdateRecord : handleSaveRecord}>
                            {isEditing ? 'Atualizar' : 'Salvar'}
                        </button>
                        <button onClick={handleCancelAddRecord}>Cancelar</button>
                    </div>
                    
                </section>
            ) : (
                <section className="group-details">
                    <div className="header-right">
                        <button className="btn-back" onClick={handleBackToCards}>
                            <FontAwesomeIcon icon={faChevronLeft} />
                        </button>
                        <div className="group-name">
                            <FontAwesomeIcon icon={getIcon(selectedGrupoDetalhes.imagem)} className="group-icon" />
                            <h2>{selectedGrupoDetalhes.titulo}</h2>
                        </div>   
                            <div className='search-container-registro'>                                 
                                <input
                                    type="text"
                                    placeholder="Buscar registros..."
                                    value={searchTerm}
                                    onChange={(e) => handleSearch(e.target.value)}
                                    className="search-input"
                                />
                                {/* {loadingSearch && (
                                    <div className="search-spinner-registro">
                                    <FontAwesomeIcon icon={faSpinner} spin />
                                    </div>
                                )} */}         
                            </div>                                        
                        <button className="btn-add-record" onClick={handleAddRecord}>Adicionar Registro</button>
                    </div>
                    {selectedGrupoDetalhes && (
                        <div className="card-details">
                            
                            <table>
                                <thead>
                                    <tr>
                                        <th></th>
                                        <th>TÍTULO</th>
                                        <th>LOGIN</th>
                                        <th>SISTEMA</th>
                                        <th>NOTAS</th>
                                        <th>OPÇÕES</th>
                                        <th>ARQUIVO</th>
                                    </tr>
                                </thead>
                                <tbody>
                                {currentRecords.length > 0 ? (
                                    currentRecords.map((registro, index) => {
                                        const fileMetadata = registro.arquivo || getFileMetadata(registro._id || registro.id);
                                        return (
                                            <tr key={registro.id || index}>
                                                    <td>
                                                        <FontAwesomeIcon
                                                            icon={registro.favorito === "fas fa-star text-warning" ? faStar : ['far', 'star']}
                                                            className="icon favorito"
                                                            onClick={() => toggleFavorito(index)}
                                                            style={{ 
                                                                color: registro.favorito === "fas fa-star text-warning" ? '#FFD700' : '#666', 
                                                                cursor: 'pointer' 
                                                            }}
                                                            title={registro.favorito === "fas fa-star text-warning" ? 'Desfavoritar' : 'Favoritar'}
                                                        />
                                                    </td>
                                                    <td>{registro.titulo}</td>
                                                    <td>
                                                        {registro.opcao_sistema === 'cartao' ? (
                                                            <span className="card-number-masked">
                                                                {formatCardNumber(registro.numero || '')}
                                                            </span>
                                                        ) : (
                                                            registro.login || ''
                                                        )}
                                                    </td>
                                                    <td>
                                                    {registro.opcao_sistema === 'cartao' ? (
                                                        <span style={{ textTransform: 'capitalize' }}>
                                                        {registro.sistema?.toLowerCase() === 'mastercard' ? 'Mastercard' :
                                                        registro.sistema?.toLowerCase() === 'visa' ? 'Visa' :
                                                        registro.sistema?.toLowerCase() === 'elo' ? 'Elo' : 
                                                        registro.sistema || 'Outro'}
                                                        </span>
                                                    ) : (registro.opcao_sistema === 'url' || isUrl(registro.sistema)) && registro.sistema ? (
                                                        <a 
                                                        href={registro.sistema.startsWith('http') ? registro.sistema : `https://${registro.sistema}`}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        onClick={(e) => e.stopPropagation()}
                                                        style={{
                                                            color: '#4a90e2', // Azul mais suave
                                                            
                                                            fontWeight: '500',
                                                          
                                                            paddingBottom: '1px'
                                                        }}
                                                        className="url-link"
                                                        >
                                                        {registro.sistema}
                                                        </a>
                                                    ) : (
                                                        registro.sistema || ''
                                                    )}
                                                    </td>

                                                    <td>{registro.notas || ''}</td>
                                                    <td>
                                                        <div className="icon-group">
                                                            {registro.tem_senha === true && (
                                                                <button
                                                                    className="mini-button"
                                                                    onClick={() => { 
                                                                        setCopiarChave(false);
                                                                        setRegistroSelecionado(registro);
                                                                        handleShowOrCopyPassword(registro);
                                                                    }}
                                                                    title={loadingSenha ? "Carregando..." : "Visualizar senha"}
                                                                >
                                                                <FontAwesomeIcon icon={faEye} />
                                                                </button>
                                                            )}
                                                            {registro.opcao_sistema !== 'cartao' && registro.tem_senha === true && (
                                                            <button
                                                                className="mini-button"
                                                                onClick={async () => { 
                                                                    setCopiarChave(true);
                                                                    setRegistroSelecionado(registro);
                                                                    handleShowOrCopyPassword(registro, true);
                                                                }}
                                                                title={loadingSenha ? "Carregando..." : "Copiar senha"}
                                                            >
                                                                <FontAwesomeIcon icon={faCopy} />
                                                            </button>
                                                            )}
                                                            

                                                            {(selectedGrupoDetalhes?.opcaoEdicao || registro.eh_responsavel) && (
                                                                <button
                                                                className="mini-button"
                                                                onClick={() => handleEditRecord(registro)}
                                                                title="Editar Registro"
                                                                >
                                                                <FontAwesomeIcon icon={faEdit} />
                                                                </button>
                                                            )}
                                                        
                                                            {(selectedGrupoDetalhes?.opcaoEdicao || registro.eh_responsavel) && (
                                                                <button
                                                                className="mini-button delete"
                                                                onClick={() => handleDeleteRecord(registro)}
                                                                title="Excluir Registro"
                                                                >
                                                                <FontAwesomeIcon icon={faTrash} />
                                                                </button>
                                                            )}
                                                            {(selectedGrupoDetalhes?.opcaoEdicao || registro.eh_responsavel) && (
                                                                <button
                                                                className="mini-button"
                                                                onClick={() => {
                                                                    setRegistroSelecionado(registro);
                                                                    setShowPermissoesModal(true);
                                                                }}
                                                                title="Gerenciar Acesso"
                                                                >
                                                                <FontAwesomeIcon icon={faUser} />
                                                                </button>
                                                            )}
                                                            {(selectedGrupoDetalhes?.opcaoEdicao || registro.eh_responsavel) && (
                                                                <button
                                                                className="mini-button"
                                                                onClick={() => {
                                                                    setRegistroSelecionado(registro);
                                                                    fetchHistorico(registro._id || registro.id);
                                                                    setShowHistoricoModal(true);
                                                                }}
                                                                title="Ver histórico"
                                                                >
                                                                <FontAwesomeIcon icon={faHistory} />
                                                                </button>
                                                            )}
                                                        </div>
                                                        </td>
                                                    <td>
                                                        {registro.hiperlink ? (
                                                            <div style={{ display: 'flex', alignItems: 'center' }} >
                                                                <span 
                                                                    className="arquivo-nome"
                                                                    onClick={() => downloadArquivoComNome(registro.hiperlink, registro.nome_arquivo)}
                                                                    style={{ cursor: 'pointer' }}
                                                                >                                                                  
                                                                </span>
                                                                <FontAwesomeIcon 
                                                                    icon={faDownload} 
                                                                    className="icon" 
                                                                    onClick={() => downloadArquivoComNome(registro.hiperlink, registro.nome_arquivo)}
                                                                    style={{ marginLeft: '8px', cursor: 'pointer' }}
                                                                    title={`Baixar o arquivo: ${registro.nome_arquivo}`}
                                                                />
                                                            </div>
                                                        ) : ''}
                                                    </td>
                                                    
                                                </tr>

                                            );
                                        })
                                    ) : (
                                        <tr><td colSpan="7">Sem registros</td></tr>
                                    )}
                                </tbody>
                            </table>
                            <div className="pagination">
                                <button onClick={prevPage} disabled={currentPage === 1}>◀</button>
                                <span> {currentPage} de {Math.ceil(filteredRecords.length / recordsPerPage)}</span>
                                <button 
                                    onClick={nextPage} 
                                    disabled={currentPage === Math.ceil(filteredRecords.length / recordsPerPage)}
                                >
                                    ▶
                                </button>
                                <div className="total">
                                    <p style={{ color: 'gray' }}><strong>Total: </strong>{filteredRecords.length}</p>
                                </div>
                            </div>
                        </div>
                    )}
                </section>
            )}

            {showDeleteConfirmation && (
                <>
                    <div className="password-popup-overlay"></div>
                    <div className='password-popup'>
                        <div className='password-popup-content'>
                            <p>Tem certeza que deseja excluir o registro "{recordToDelete?.titulo}"?</p>
                            <div className='password-popup-buttons'>
                                <button
                                    className='btn-copy'
                                    onClick={confirmDelete}
                                >
                                    Confirmar
                                </button>
                                <button
                                    className='btn-close'
                                    onClick={() => setShowDeleteConfirmation(false)}
                                >
                                    Cancelar
                                </button>
                            </div>
                        </div>
                    </div>
                </>
            )}
            <CartaoModal 
                show={showCartaoModal}
                fecharModal={() => setShowCartaoModal(false)}
                cartao={cartaoSelecionado}
            />

            <HistoricoModal
                show={showHistoricoModal}
                fecharModal={() => setShowHistoricoModal(false)}
                historico={historico}
                loading={loadingHistorico}              
                showToast={showToast}
                getCookie={getCookie}
            />

            <ModalPermissoesGrupo          
                showToast={showToast}
            />

            <ModalPermissoes
                show={showPermissoesModal}
                fecharModal={() => setShowPermissoesModal(false)}
                registroId={registroSelecionado?._id || registroSelecionado?.id}
                grupoId={selectedGrupoDetalhes?.id}
                getCookie={getCookie}
                showToast={showToast}
            />

            <VerificarAcessoModal
                show={showVerificarAcessoModal}
                fecharModal={() => setShowVerificarAcessoModal(false)} 
                cancelarVerificacao={cancelarVerificacao}
                verificarCodigo={verificarCodigo}
                showVerificarAcessoModal={showVerificarAcessoModal}
                registro={registroSelecionado}
                validarOTP={validarOTP}
                getCookie={getCookie}
                showToast={showToast}

            />
        </>
    );
};

export default Registro;
